
<template> 
  <v-app>   
    
    <v-row>
      <v-col><div id="mapid" style="height: 100%; width: 100%;"></div></v-col>

      <v-col cols="3">
        <v-btn :color="isplayback?'red':'green'" small @click="isplayback? stopplayback() : playback()"  ><v-icon>{{isplayback?'mdi-stop':'mdi-play'}}</v-icon> {{isplayback?'Stop Play':'Play Back'}}</v-btn>
        <br>
        <v-data-table
                  class="elevation-1 pt-3"
                  :headers="headers"
                  :items="isplayback? playbackdata : tracking_data" 
                  fixed-header 
                  loading-text="Loading... Please wait"
                  item-key="dt_tracker">
                </v-data-table>
      </v-col>

    </v-row>
  </v-app>
</template> 

<style>
#mapid {
  position: relative;
  height: 100% !important;
  z-index: 0;
}
</style>

<script>
import moment from "moment";
import vue from "vue";
import MapPopup from "../helpers/popup";

export default {
  name: "Map",
  data() {
    return {
      map: "",
      zoom: 14,
      otm: L.tileLayer("https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png", {
        id: "otm",
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
      }),
      osm: L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        id: "osm",
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }),
      mapbox: L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          id: "mapbox/streets-v11",
          accessToken: "your.mapbox.access.token",
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
        }
      ),
      googleStreets : L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z=12',{ 
                minZoom: 8,
                maxZoom: 17, 
                subdomains:['mt0','mt1','mt2','mt3']
            }), 
            googleHybrid : L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z=12',{ 
                minZoom: 8,
                maxZoom: 17, 
                subdomains:['mt0','mt1','mt2','mt3']
            }), 
            googleSat : L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z=12',{ 
                minZoom: 8,
                maxZoom: 17, 
                subdomains:['mt0','mt1','mt2','mt3']
            }),
            googleTerrain :  L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z=12',{ 
                minZoom: 8,
                maxZoom: 17, 
                subdomains:['mt0','mt1','mt2','mt3']
            }),
      mapMarkers: [],
      headers: [
        { text: "Date", value: "dt_tracker" },  
        { text: "Speed KPH", value: "speed"},
        // { text: "Address", value: "current_loc" }
      ],  
      isplayback: false,
      playbackdata: [],
      polling: null,
      overspeed: process.env.VUE_APP_COUNTRY=='RWANDA'? 60 : 80,
    };
  },
  props: {
    tracking_data: Array
  },
  methods: {
    playback(){
      this.isplayback = true;
      this.playbackdata =[];
      var index =0;
      this.polling = setInterval(() => { 
        if (this.tracking_data.length ==  index+1) {
           clearInterval(this.polling)
           this.isplayback = false;
        } else {
          this.playbackdata.unshift(this.tracking_data[index]);
        }  
        index++;
        if(this.playbackdata.length>0)
        this.setMapData();
      }, 3000); 
     
    },

    stopplayback(){
      clearInterval(this.polling)
      this.isplayback = false;
      this.setMapData();
    },

    initMap() {
      this.map = L.map("mapid", { layers: [this.osm] });
      L.control
         .layers(
                    { "Open Street Map": this.osm ,
                    "Open Topo Map": this.otm , 
                    "Google Street": this.googleStreets ,
                    "Google Hybrid": this.googleHybrid ,
                    "Google Satellite": this.googleSat ,
                    "Google Terrain": this.googleTerrain,
                    // "Google Traffic": this.googleTraffic
                 },{}, { collapsed: true }
                )
        .addTo(this.map);
      this.setMapData();
    },

    setMapData() { 
      if (this.mapMarkers.length > 0) {
        for (var i = 0; i < this.mapMarkers.length; i++) {
          this.map.removeLayer(this.mapMarkers[i]);
        }
        this.mapMarkers = [];
      }

      if((this.isplayback?this.playbackdata :  this.tracking_data).length>0){
        var bound = [];
        (this.isplayback?this.playbackdata :  this.tracking_data).map(vehicle => { 
          var html = "";
          if (vehicle.speed == 0 && vehicle.engineon)
                        html = '<span class="wlt_marker_icon IgnOn_SpdisZro" style="-ms-transform: rotate(' + vehicle.angle + 'deg);transform: rotate(' + vehicle.angle + 'deg);--my-color-var:--my-color-var: #fbc01f;"></span>';
                    else if (vehicle.speed == 0 && !vehicle.engineon)
                        html = '<span class="wlt_marker_icon IgnOff" style="-ms-transform: rotate(' + vehicle.angle + 'deg);transform: rotate(' + vehicle.angle + 'deg);--my-color-var:--my-color-var: grey;"></span>';
                    else if (vehicle.speed > 0 && vehicle.speed <= this.overspeed)
                        html = '<span class="wlt_marker_icon IgnOn_SpdnotZro" data-icon="dashicons:location" data-inline="false" style="-ms-transform: rotate(' + vehicle.angle + 'deg);transform: rotate(' + vehicle.angle + 'deg);--my-color-var:--my-color-var: #8ba846;"></span>';
                    else if (vehicle.speed > this.overspeed)
                        html = '<span class="wlt_marker_icon Overspid" data-icon="dashicons:location" data-inline="false" style="-ms-transform: rotate(' + vehicle.angle + 'deg);transform: rotate(' + vehicle.angle + 'deg);--my-color-var:--my-color-var: red;"></span>';

          var myIcon = L.divIcon({
            className: "my-div-icon",
            html: html
          });

          var popup = new vue({
            ...MapPopup,
            parent: this,
            propsData: { vehicle }
          }).$mount();

          bound.push(new L.LatLng(vehicle.lat, vehicle.lng));

          var marker = L.marker(
            [parseFloat(vehicle.lat), parseFloat(vehicle.lng)],
            {
              icon: myIcon
            }
          )
            .addTo(this.map)
            .bindPopup(popup.$el.innerHTML);
          this.mapMarkers.push(marker);
        });
        if (bound.length > 0) this.map.fitBounds(new L.LatLngBounds(bound));
      }
    }
  },
  mounted() {
    this.initMap();
  },
};
</script>
